import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { Box, Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
    const location = useLocation();
    return (
        <Grid container spacing={1}>
            {!['/login', '/admin'].includes(location.pathname) && (
                <Grid item size={{ md: 2 }}>
                    <Sidebar />
                </Grid>
            )}
            <Grid item size={{ md: !['/login', '/admin'].includes(location.pathname) ? 10 : 12 }}>
                {!['/login', '/admin'].includes(location.pathname) && (
                    <Header />
                )}
                <Box sx={{ height: 'calc(100vh - 4px)', overflowY: 'auto' }}>
                    {children}
                </Box>
            </Grid>
        </Grid>
    );
};

export default Layout;
